import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { modalController } from '@ionic/vue';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import AppLoadingAlert from '@/components/AppLoadingAlert.vue';
import DraggableVideo from '@/components/DraggableVideo.vue';
import Phq9FormModal from '@/components/Phq9FormModal.vue';
import TheShellFooter from '@/components/TheShellFooter.vue';
import TheShellHeader from '@/components/TheShellHeader.vue';
import TheShellSideMenu from '@/components/TheShellSideMenu.vue';
import useCall from '@/composables/global/use-call';
import useInitLoader from '@/composables/global/use-init-loader';
import usePhq9 from '@/composables/global/use-phq9';
import useResponsiveness from '@/composables/global/use-responsiveness';
import useShellHeader from '@/composables/global/use-shell-header';
import useStorageUpload from '@/composables/use-storage-upload';
const LOAD_MESSAGE_TIMEOUT = 5 * 1000;
export default /*#__PURE__*/_defineComponent({
  __name: 'TheShell',
  setup(__props) {
    const {
      appDataInitialized
    } = useInitLoader();
    const {
      isMenuCollapsed
    } = useShellHeader();
    const {
      mdUp
    } = useResponsiveness();
    const {
      userMustCompletePhq9
    } = usePhq9();
    const {
      isPictureInPicture,
      disconnectOnRefresh
    } = useCall();
    const {
      setFileInputRef
    } = useStorageUpload();
    const {
      t
    } = useI18n({
      useScope: 'global',
      messages: {
        en: {
          loadingMessage: 'Loading, please wait...'
        },
        es: {
          loadingMessage: 'Cargando, por favor espere...'
        }
      }
    });
    const fileInputRef = ref();
    /** Delay in ms before spinner shows for long app data init load times */
    const showLoadMessage = ref(false);
    const loadMessageTimeout = setTimeout(() => {
      showLoadMessage.value = true;
    }, LOAD_MESSAGE_TIMEOUT);
    function hideLoadMessage() {
      clearTimeout(loadMessageTimeout);
      // Timeout to ensure message is shown for a minimum time
      setTimeout(() => showLoadMessage.value = false, 1000);
    }
    async function showPhq9FormModal() {
      const phq9Form = await modalController.create({
        id: 'phq9Form',
        component: Phq9FormModal,
        backdropDismiss: false
      });
      phq9Form.present();
    }
    onMounted(async () => {
      await appDataInitialized();
      hideLoadMessage();
      setFileInputRef(fileInputRef.value);
      const mustCompletePhq9 = await userMustCompletePhq9();
      if (mustCompletePhq9) {
        await showPhq9FormModal();
      }
      await disconnectOnRefresh();
    });
    return (_ctx, _cache) => {
      const _component_ion_page = _resolveComponent("ion-page");
      const _component_ion_split_pane = _resolveComponent("ion-split-pane");
      const _component_ion_app = _resolveComponent("ion-app");
      return _openBlock(), _createBlock(_component_ion_app, null, {
        default: _withCtx(() => [_createVNode(_component_ion_split_pane, {
          class: _normalizeClass(_unref(isMenuCollapsed) ? 'pane-collapsed' : 'pane-expanded'),
          when: _unref(mdUp),
          "content-id": "main-content"
        }, {
          default: _withCtx(() => [_createVNode(TheShellSideMenu, {
            mini: _unref(isMenuCollapsed) && _unref(mdUp),
            "content-id": "main-content"
          }, null, 8, ["mini"]), _createVNode(_component_ion_page, {
            id: "main-content"
          }, {
            default: _withCtx(() => [_createVNode(TheShellHeader), _renderSlot(_ctx.$slots, "default"), _createVNode(TheShellFooter), _createVNode(AppLoadingAlert, {
              isShowing: showLoadMessage.value,
              message: _unref(t)('loadingMessage')
            }, null, 8, ["isShowing", "message"])]),
            _: 3
          })]),
          _: 3
        }, 8, ["class", "when"]), _createElementVNode("input", {
          ref_key: "fileInputRef",
          ref: fileInputRef,
          class: "ion-hide",
          type: "file"
        }, null, 512), _unref(isPictureInPicture) ? (_openBlock(), _createBlock(DraggableVideo, {
          key: 0
        })) : _createCommentVNode("", true)]),
        _: 3
      });
    };
  }
});